export default {
  changeasset:
    "El activo fue actualizado por otro usuario mientras tanto y sus cambios no se pueden almacenar. Por favor, inténtelo de nuevo.",
  general: "General",
  header: "Atención",
  noDataAvailable: "No hay datos disponibles...",
  noSavetyNotes: "Aún no se han creado notas de seguridad",
  noAssets: "no hay más activos nuevos para este organización",
  errorPage: "¡Ups, ocurrió un error!",
  invalidLatitude: "Latitud inválida",
  invalidLongitude: "Longitud inválida",
};
